import { ref } from 'vue';

/**
 * The in-flight flag every store exposes as `apiLoading`. Views read it to
 * disable submit buttons and show spinners.
 */
export function useApiLoading() {
  const apiLoading = ref<boolean>(false);

  const setApiLoading = () => (apiLoading.value = true);
  const setApiDone = () => (apiLoading.value = false);

  return { apiLoading, setApiLoading, setApiDone };
}
